import React from "react";

export const EnergetiqueIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none">
      <path
        d="M14.9996 3.75C8.9996 3.75 3.7496 8.575 3.7496 15C3.7496 17.65 4.6746 20.0875 6.2121 22.0125L4.1121 24.1125C3.87837 24.3462 3.74707 24.6632 3.74707 24.9938C3.74707 25.3243 3.87837 25.6413 4.1121 25.875C4.34582 26.1087 4.66281 26.24 4.99335 26.24C5.32388 26.24 5.64087 26.1087 5.8746 25.875L7.9746 23.775C9.96534 25.3773 12.4441 26.2506 14.9996 26.25C17.8746 26.25 20.7621 25.15 22.9496 22.95C23.9973 21.9084 24.8284 20.6696 25.3948 19.3051C25.9612 17.9406 26.2517 16.4774 26.2496 15V6.25C26.2496 4.875 25.1246 3.75 23.7496 3.75H14.9996ZM19.7871 15.325L13.3371 21.1125C13.1371 21.3 12.8246 21.2875 12.6371 21.1C12.5524 21.0155 12.5008 20.9035 12.4916 20.7843C12.4824 20.665 12.5163 20.5464 12.5871 20.45L15.6371 16.2875L10.5746 15.7875C10.4509 15.7759 10.3332 15.7287 10.2358 15.6516C10.1384 15.5745 10.0655 15.4708 10.0258 15.353C9.98611 15.2353 9.98141 15.1086 10.0123 14.9883C10.0431 14.8679 10.1082 14.7591 10.1996 14.675L16.6496 8.8875C16.8496 8.7 17.1621 8.7125 17.3496 8.9C17.5246 9.075 17.5496 9.35 17.3996 9.55L14.3496 13.7125L19.4121 14.2125C19.9746 14.2625 20.1996 14.95 19.7871 15.325Z"
        fill="#2481A6"
      />
    </svg>
  );
};
